/*
 * @Description:
 * @Author: Rfan
 * @Date: 2021-08-13 09:25:46
 * @LastEditTime: 2024-01-10 14:59:17
 */
import Vue from 'vue';
import VueRouter from 'vue-router';
import Service from '../views/Service.vue';
import { testApp } from '@/utils';

Vue.use(VueRouter)

const isHsjPro = testApp('hsjpro');

const routes = [
  {
    path: '/',
    redirect: '/service'
  },
  {
    path: '/service',
    name: 'service',
    component: Service,
    meta: {
      title: '画世界用户协议'
    },
  },
  {
    path: '/service/hsjpro',
    name: 'HsjProService',
    component: () => import(/* webpackChunkName: "HsjProService" */ '../views/hsjpro/Service.vue'),
    meta: {
      title: '画世界Pro用户协议'
    },
  },
  {
    path: '/privacy/:app?/:languages?',
    name: 'privacy',
    component: () =>
      import(/* webpackChunkName: "privacy" */ '../views/Privacy.vue'),
    meta: {
      title: '隐私政策'
    }
  },
  {
    path: '/permissions',
    name: 'Permissions',
    component: () =>
      import(/* webpackChunkName: "Permissions" */ '../views/Permissions.vue'),
    meta: {
      title: '设备权限清单'
    }
  },
  {
    path: '/member/:app?',
    name: 'member',
    component: () =>
      import(/* webpackChunkName: "member" */ '../views/Member.vue'),
    meta: {
      title: isHsjPro ? '画世界Pro会员协议' : '画世界会员协议'
    }
  },
  {
    path: '/term/:app?',
    name: 'term',
    component: () => import(/* webpackChunkName: "term" */ '../views/Term.vue'),
    meta: {
      title: '自动续费规则'
    }
  },
  {
    path: '/face',
    name: 'face',
    component: () => import(/* webpackChunkName: "face" */ '../views/Face.vue'),
    meta: {
      title: isHsjPro ? '画世界Pro人脸验证服务协议' : '画世界人脸验证服务协议'
    }
  },
  {
    path: '/rightsandobligations/transfer/hsjpro',
    name: 'TransferOfRightsAndObligations',
    component: () => import(/* webpackChunkName: "TransferOfRightsAndObligations" */ '../views/hsjpro/TransferOfRightsAndObligations.vue'),
    meta: {
      title: "画世界Pro权利义务转让协议"
    }
  },
  {
    path: '/mojing/hsjpro/service',
    name: 'MojingHsjProService',
    component: () => import(/* webpackChunkName: "MojingHsjProService" */ '../views/mojinghsjpro/Service.vue'),
    meta: {
      title: '画世界Pro用户协议'
    },
  },
  {
    path: '/mojing/hsjpro/privacy',
    name: 'MojingHsjProPrivacy',
    component: () =>
      import(/* webpackChunkName: "MojingHsjProPrivacy" */ '../views/mojinghsjpro/Privacy.vue'),
    meta: {
      title: '画世界Pro隐私政策'
    }
  },
  {
    path: '/mojing/hsjpro/member',
    name: 'MojingHsjProMember',
    component: () =>
      import(/* webpackChunkName: "MojingHsjProMember" */ '../views/mojinghsjpro/Member.vue'),
    meta: {
      title: '画世界Pro会员协议'
    }
  },
  {
    path: '/opensource/:app?/:platform?',
    name: 'OpenSource',
    component: () =>
      import(/* webpackChunkName: "OpenSource" */ '../views/OpenSource.vue'),
    meta: {
      title: '开源软件声明'
    }
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }

  next()
});

export default router
